import { createContext, memo, ReactNode, useState } from "react";
import { AddFundsModal } from "./add-funds-modal";

export interface AddFundsParams {
  labelPrice: number;
  balance?: string;
  balanceLoading: boolean;
  onSuccess: () => void;
}

export const AddFundsModalContext = createContext<
  (params: AddFundsParams) => void
>(() => {});

export const AddFundsModalProvider = memo(function AddFundsModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [params, setParams] = useState<AddFundsParams | null>(null);
  const [open, setOpen] = useState(false);

  const openModal = (newParams: AddFundsParams) => {
    setParams(newParams);
    setOpen(true);
  };

  return (
    <AddFundsModalContext.Provider value={openModal}>
      {children}
      {params && (
        <AddFundsModal
          balance={params.balance}
          balanceLoading={params.balanceLoading}
          isOpen={open}
          labelPrice={params.labelPrice}
          onModalCloseRequested={() => setOpen(false)}
          onSuccess={() => {
            setOpen(false);
            params.onSuccess();
          }}
        />
      )}
    </AddFundsModalContext.Provider>
  );
});
